export const sortDirectionMap: Record<string, string> = {
  ascend: "asc",
  descend: "desc",
};
